// extracted by mini-css-extract-plugin
export default {"resetButton":"AH_9FnK","controlPanel":"XdBoBB7","tooltip":"DNMqyet"};